export const DEBUG_STORAGE_KEY = "qq_debug";

/** Safe wrappers to satisfy eslint and avoid empty blocks */
function safeGetItem(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch (err) {
    // In private mode or restricted environments, storage can throw.
    // Log at debug level so production logs don't get noisy.
    console.debug("[QuickQuiz] localStorage.getItem failed:", err);
    return null;
  }
}

function safeSetItem(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch (err) {
    console.debug("[QuickQuiz] localStorage.setItem failed:", err);
  }
}

export function isDebugEnabled(): boolean {
  // 1) Query param has highest precedence
  try {
    const url = new URL(window.location.href);
    const q = url.searchParams.get("debug");
    if (q != null) {
      const v = q.toLowerCase();
      return v === "1" || v === "true";
    }
  } catch (err) {
    console.debug("[QuickQuiz] URL parse failed:", err);
  }

  // 2) Persisted flag
  const stored = safeGetItem(DEBUG_STORAGE_KEY);
  if (stored != null) return stored === "1";

  // 3) Default
  return false;
}

export function setDebugEnabled(enabled: boolean): void {
  safeSetItem(DEBUG_STORAGE_KEY, enabled ? "1" : "0");
  try {
    window.dispatchEvent(
      new CustomEvent("qq:debug-changed", { detail: enabled })
    );
  } catch (err) {
    console.debug("[QuickQuiz] dispatchEvent failed:", err);
  }
}

/**
 * If the location hash is exactly '#toggle-debug', flip the flag and reload.
 * Useful as a production backdoor: append #toggle-debug to any app URL.
 */
export function installHashToggleOnce(): void {
  try {
    if (window.location.hash === "#toggle-debug") {
      const next = !isDebugEnabled();
      setDebugEnabled(next);

      // Clean URL: remove hash and any ?debug=... query before reloading
      const url = new URL(window.location.href);
      url.hash = "";
      url.searchParams.delete("debug");
      history.replaceState(null, "", url.toString());

      window.location.reload();
    }
  } catch (err) {
    console.debug("[QuickQuiz] installHashToggleOnce failed:", err);
  }
}

